import type { NodeId } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import type { DraftStateUpdater } from 'utils/react/StateProxy';

type UpdateNodesVisibility = () => void;

export const makeUpdateNodesVisibility =
  (
    updateState: DraftStateUpdater<GraphState>,
    nodeIds: NodeId[],
    visible: boolean,
    peekingAtHiddenNodes: boolean,
  ): UpdateNodesVisibility =>
  () => {
    let emptyHiddenNodes = false;
    updateState((draft) => {
      for (const nodeId of nodeIds) {
        draft.graph.hiddenNodes[visible ? 'delete' : 'add'](nodeId);

        emptyHiddenNodes = draft.graph.hiddenNodes.size === 0;
      }
    });

    if (emptyHiddenNodes && peekingAtHiddenNodes) {
      updateState((draft) => {
        draft.peekingAtHiddenNodes = false;
      });
    }

    if (!emptyHiddenNodes && peekingAtHiddenNodes) {
      updateState((draft) => {
        draft.peekingAtHiddenNodes = true;
      });
    }
  };
